import {autobind} from 'core-decorators';

import {Component} from 'inferno';

interface ButtonProps {
    className?: string;
    clickLabel?: string;
    onClick?: Function;
}

export class InputButton extends Component<ButtonProps & JSX.IntrinsicElements['input']> {
    originalOnClick?: Function;

    @autobind
    handleClick(event: Event) {
        this.originalOnClick?.(event);

        if (this.props.clickLabel) {
            window.gaEvent({
                category: 'button',
                action: 'click',
                label: this.props.clickLabel,
            });
        }
    }
    render() {
        const {clickLabel, onClick, ...props} = this.props;

        this.originalOnClick = onClick;
        (props as any).onClick = this.handleClick;

        return <input {...props}/>;
    }
}

export class Button extends Component<ButtonProps & JSX.IntrinsicElements['button']> {
    originalOnClick?: Function;

    @autobind
    handleClick(event: Event) {
        this.originalOnClick?.(event);

        if (this.props.clickLabel) {
            window.gaEvent({
                category: 'button',
                action: 'click',
                label: this.props.clickLabel,
            });
        }
    }
    render() {
        const {clickLabel, onClick, ...props} = this.props;

        this.originalOnClick = onClick;
        (props as any).onClick = this.handleClick;

        return <button {...props}/>;
    }
}
